import createMemoizedSelector from 'redux/selectors/createMemoizedSelector';
import { hasImmune } from 'const/enums/Modality';
var getHasImmune = function getHasImmune() {
  return function (state) {
    var _state$info$modalitie;
    return hasImmune((_state$info$modalitie = state.info.modalities) !== null && _state$info$modalitie !== void 0 ? _state$info$modalitie : []);
  };
};
export default createMemoizedSelector(getHasImmune);